var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutres(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.597 68.2499C95.3374 56.6299 69.0874 44.9999 42.8174 33.3799V155.68C60.2474 164.34 77.6674 172.99 95.0974 181.64L111.022 216.977L132.087 200.01C153.567 210.67 175.103 221.325 196.573 231.995C197.223 210.515 197.807 189.04 198.447 167.56C199.087 146.08 199.727 124.61 200.377 103.12C174.107 91.4999 147.847 79.8699 121.587 68.2499H121.597Z",
    fill: "#B2E8C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2174 18L42.8174 33.38L200.387 103.12C207.527 96.85 214.647 90.58 221.787 84.31C170.937 62.21 120.067 40.1 69.2174 18Z",
    fill: "#72D09A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M196.569 232.004L198.647 102.403C205.787 96.1328 214.688 90.5801 221.828 84.3101L220.248 204.45",
    fill: "#29A063"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3375 128.25C86.6675 128.25 90.9775 122.63 90.9775 115.71C90.9775 108.79 86.6575 103.17 81.3375 103.17C76.0175 103.17 71.6975 108.79 71.6975 115.71C71.6975 122.63 76.0175 128.25 81.3375 128.25Z",
    fill: "#F97E73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.537 144.26C122.867 144.26 127.187 138.64 127.187 131.72C127.187 124.8 122.867 119.18 117.537 119.18C112.207 119.18 107.897 124.8 107.897 131.72C107.897 138.64 112.217 144.26 117.537 144.26Z",
    fill: "#F97E73"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.047 160.03C162.377 160.03 166.687 154.41 166.687 147.49C166.687 140.57 162.367 134.95 157.047 134.95C151.727 134.95 147.407 140.57 147.407 147.49C147.407 154.41 151.727 160.03 157.047 160.03Z",
    fill: "#F97E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutres);
export default __webpack_public_path__ + "static/media/autres.0707101accf9185be3e443c9aa372f3e.svg";
export { ForwardRef as ReactComponent };